import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { HeaderStateService } from '../../../main/headers/services/header-state.service';
import { AssignmentEventTypeEnum } from '../../../shared/enums/assignment-event-type.enum';
import { AssignmentTakeoverModel } from '../../models/assignment-takeover.model';
import { AssignmentsOverviewModel } from '../../models/assignments-overview.model';
import { AssignmentStateService } from '../../services/assignment-state.service';
import { AssignmentsFilterStateService } from '../../services/assignments-filter-state.service';
import { AssignmentsFilterModalComponent } from '../assignments-filter-modal/assignments-filter-modal.component';
import { OpenAssignmentsModalComponent } from '../open-assignments-modal/open-assignments-modal.component';

@Component({
    templateUrl: './open-assignments.component.html',
    styleUrl: './open-assignments.component.scss',
    providers: [AssignmentsFilterStateService]
})
export class OpenAssignmentsComponent implements OnInit {
    selectedAssignments: AssignmentsOverviewModel[] = [];
    assignmentEventType = AssignmentEventTypeEnum;
    modalRef?: BsModalRef;

    constructor(
        private assignmentsFilterStateService: AssignmentsFilterStateService,
        private headerStateService: HeaderStateService,
        private bsModalService: BsModalService,
        public assignmentsStateService: AssignmentStateService,
        private translocoService: TranslocoService
    ) {
        this.headerStateService.setDetailHeader(
            this.translocoService.translate('main.header.openAssignmentsTitle'),
            this.translocoService.translate('main.header.openAssignmentsDescription'),
            '/assignments',
            'fa-solid fa-filter text-primary'
        );
    }

    ngOnInit(): void {
        let currentFilter = this.assignmentsStateService.openAssignmentsFilterSubject.value;
        this.assignmentsStateService.loadOpenAssignments(currentFilter);
        this.registerEvents();
    }

    public openTakeoverModal(): void {
        const takeoverAssignments = this.selectedAssignmentsToAssignmentTakeoverModels(this.selectedAssignments);

        const initialState = { takeoverAssignments: takeoverAssignments, selectedAssignmentsCount: this.selectedAssignments.length };
        this.modalRef = this.bsModalService.show(OpenAssignmentsModalComponent, {
            ignoreBackdropClick: true,
            initialState
        });
        this.modalRef?.content.onSuccess.subscribe((success: boolean) => {
            if (success) {
                let currentFilter = this.assignmentsStateService.openAssignmentsFilterSubject.value;
                this.assignmentsStateService.loadOpenAssignments(currentFilter);
                this.resetSelectedAssignments();
            }
        })
    }

    public onAssignmentSelected(assignments: AssignmentsOverviewModel[]): void {
        this.selectedAssignments = assignments;
    }

    public openFilterModal(): void {
        this.modalRef = this.bsModalService.show(AssignmentsFilterModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                isFilterForPastAssignmentEnabled: false
            }
        });
        this.modalRef.content.assignmentsFilterSubject = this.assignmentsStateService.openAssignmentsFilterSubject;
        this.modalRef.content.loadSavedFilters();
    }

    private resetSelectedAssignments(): void {
        this.selectedAssignments = [];
    }

    private selectedAssignmentsToAssignmentTakeoverModels(selectedAssignments: AssignmentsOverviewModel[]): AssignmentTakeoverModel[] {

        let exchangeModel = selectedAssignments.map(x => {
            let model: AssignmentTakeoverModel =
            {
                assignment: x,
                isSuccess: null,
                errorMessage: null
            };

            return model;
        });

        return exchangeModel;
    }

    // call only once in ngOnInit
    private registerEvents(): void {
        // Opening FilterModal in the Header
        this.headerStateService.getActionClickedEvent().subscribe((x) => {
            this.openFilterModal();
        });

        this.assignmentsFilterStateService.getIsAnyFilterDisplayedEvent().subscribe(x => {
            this.headerStateService.updateIsActiveStatusIndicatorDisplayed(x);
        });
    }
}
